export default "__VITE_ASSET__$A9F83DS__"